// opervex-frontend/src/Opervex/HumanResources/Roles.js

class Roles {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  // Create
  async create(data) {
    return this.#_api.post("/HumanResources/Roles/", data);
  }

  // Update
  async update(id, data) {
    return this.#_api.put("/HumanResources/Roles/" + id, data);
  }

  // Find By Id
  async findId(id) {
    return this.#_api.get("/HumanResources/Roles/" + id);
  }

  // Find All
  async findAll() {
    return this.#_api.get("/HumanResources/Roles");
  }

  // Schema
  async schema() {
    return [
      {
        key: "id",
        label: "Código",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "description",
        label: "Descrição",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "externalCode",
        label: "Código Externo",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "disabled",
        label: "Inatívo",
        type: "boolean",
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default Roles;
